import { render, staticRenderFns } from "./ConfigWebsiteCatalogueEdit.vue?vue&type=template&id=a80db7be&scoped=true"
import script from "./ConfigWebsiteCatalogueEdit.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueEdit.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueEdit.vue?vue&type=style&index=0&id=a80db7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80db7be",
  null
  
)

export default component.exports